import React from "react";
import { Modal, Button, FormGroup, Input } from "reactstrap";

function AuthorSelection(props) {
  let { user } = props;
  if (!user) return null;
  if (!user.role) return null;
  let minWeek = user.role.id === 600 ? 1 : 0;
  let maxWeek = user.role.id === 600 ? 4 : 52;
  for (var i = minWeek, weeksOption = []; i < maxWeek + 1; i++)
    weeksOption.push(i);

  return (
    <Modal
      className="modal-dialog-centered modal-sm"
      isOpen={props.operationNewModal}
      toggle={() => props.toggleNewModal()}
    >
      <div className="modal-header">
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => props.toggleNewModal()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        {/* {props.sub.errorMsg} */}
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => props.handleCheckBoxChange(e)}
          >
            {props.categories.map((cat, key) => (
              <option
                selected={
                  props.data.category_ids
                    ? props.data.category_ids.indexOf(cat.id) !== -1
                    : false
                }
                value={cat.id}
              >
                {cat.display_name}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => props.onTextInputChange(e, "type")}
          >
            <option selected={props.data.type === "right"} value={"right"}>
              側邊廣告
            </option>
            <option selected={props.data.type === "top"} value={"top"}>
              置頂廣告
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">期限</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => props.onTextInputChange(e, "vacancy_weeks")}
          >
            {weeksOption.map(val => (
              <option
                key={`week-${val}`}
                selected={props.data.vacancy_weeks === val}
                value={val}
              >
                {val === 0 ? "永久" : `${val}週`}
              </option>
            ))}
          </Input>
        </FormGroup>

        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={() => props.toggleNewModal()}
          >
            取消
          </Button>
          <Button
            color="default"
            type="button"
            onClick={() => props.submitArticle()}
          >
            添加分類廣告
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default AuthorSelection;
